import React, { useEffect, useRef, useState } from 'react';
import Icon from '@sabre/spark-react-core/icon';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { isEmpty } from 'lodash';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { DateUtil } from '../../utils/date-util.js';
import { getDefaultDateRanges } from './date-range-until.js';

// https://github.com/hypeserver/react-date-range

const DateRange = ({ configs, iconSize, isForceRender }) => {
   const {
      inputElementDateRangeId,
      format,
      minDate,
      maxDate,
      startDate,
      endDate,
      enableRanges,
      ranges,
      recommCompetitor,
      dateOnChangeHandler,
   } = configs;

   const keyRef = useRef(Date.now());
   const [sDate, setSDate] = useState(startDate);
   const [tDate, setTDate] = useState(endDate);
   const [defaultRanges, setDefaultRanges] = useState(
      getDefaultDateRanges(format, recommCompetitor)
   );

   useEffect(() => {
      setSDate(startDate);
      setTDate(endDate);
   }, [startDate, endDate]);

   useEffect(() => {
      keyRef.current = Date.now();
      setDefaultRanges(getDefaultDateRanges(format, recommCompetitor));
   }, [isForceRender, recommCompetitor]);

   return isEmpty(minDate) || isEmpty(maxDate) ? null : (
      <DateRangePicker
         key={keyRef.current}
         onCallback={dateOnChangeHandler}
         initialSettings={{
            minDate: DateUtil.formatDate(minDate, format),
            maxDate: DateUtil.formatDate(maxDate, format),
            startDate: DateUtil.formatDate(sDate, format),
            endDate: DateUtil.formatDate(tDate, format),
            ranges: enableRanges && isEmpty(ranges) ? defaultRanges : ranges,
         }}
      >
         <div className='date-range-container'>
            <input
               className='spark-input__field date-range-input-element'
               type='text'
               id={inputElementDateRangeId}
               value={`From: ${sDate} - To: ${tDate}`}
            />
            <span className='date-range-input-element-icon'>
               <Icon name='calendar' size={iconSize} label='Show Calendar' />
            </span>
         </div>
      </DateRangePicker>
   );
};

DateRange.propTypes = {};

export default DateRange;
